import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigManagerComponent } from './config-manager.component';
import { ConfigListComponent } from './components/config-list/config-list.component';
import { ConfigEditorComponent } from './components/config-editor/config-editor.component';

const routes: Routes = [
  {
    path: '',
    component: ConfigManagerComponent,
    children: [
      {
        path: ':consumerKey',
        component: ConfigListComponent
      },
      {
        path: ':consumerKey/:configKey',
        component: ConfigEditorComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigManagerRoutingModule { }
